module.exports = __webpack_public_path__ + "img/6.9ec5dd71.png";